import { styled } from '@mui/styles';
import { Link } from 'react-router-dom';

export const PropertyCard = styled(Link)({
  textDecoration: 'none',
  color: 'inherit !important',
});
